export function checkChromeExtension(boolean) {
  return function (dispatch) {
    dispatch({
      type: 'CHROME_EXTENSION',
      payload: boolean,
    });
  };
}
